import React from 'react'
import NavBar from "./NavBar";
import Footer from "./Footer";

const AbtSchemeUI = () => { return (
<div>
      <NavBar />
      <main id="main">
      <section id="abtScheme" class="innerPage">
            <div class="container">
                <div class="section-title">
                    <h2>Retail Direct Scheme</h2>
                </div>
                <div>
                    <p>
                        As part of continuing efforts to increase retail participation in government securities, ‘the RBI Retail Direct’ facility was announced in the Statement of Developmental and Regulatory Policies dated February 05, 2021 for improving ease of access by retail
                        investors through online access to the government securities market – both primary and secondary - along with the facility to open their gilt securities account (‘Retail Direct’) with the RBI.
                    </p>
                    <p>
                        In pursuance of this announcement, the ‘RBI Retail Direct’ scheme, which is a one-stop solution to facilitate investment in Government Securities by individual investors has been issued. The highlights of the ‘RBI Retail Direct’ scheme are:
                    </p>
                    <ol>
                        <li>
                            Retail investors (individuals) will have the facility to open and maintain the ‘Retail Direct Gilt Account’ (RDG Account) with RBI.
                        </li>
                        <li>
                            RDG Account can be opened through an ‘Online portal’ provided for the purpose of the scheme.
                        </li>

                        <li>
                            The ‘Online portal’ will also give the registered users the following facilities:
                            <ol>
                                <li>
                                    Access to primary issuance of Government securities
                                </li>
                                <li>
                                    Access to NDS-OM.
                                </li>
                            </ol>
                        </li>
                    </ol>
                    <p>
                        The scheme of Reserve Bank of India (RBI) Retail Direct has been formulated as a one-stop solution to facilitate investment in Government Securities by individual investors.
                    </p>
                    <h5>I. Definitions</h5>
                    <p>
                        Terms used in this document shall bear the meaning assigned to them as under:
                        <ol type="i">
                            <li>
                                a. Aggregator / Receiving Office means Clearing Corporation of India Limited (CCIL) or any other entity as may be approved by RBI under the scheme;
                            </li>
                            <li>

                                b. Government securities, for the purpose of this scheme, mean securities issued in form of stock by credit to SGL/CSGL account maintained with RBI as defined under Section 3(iii) of Government Securities Act 2006. These include:
                                <br/> i) Government of India Treasury Bills;<br/> ii) Government of India dated securities;<br/> iii) Sovereign Gold Bonds (SGB);<br/> iv) State Development Loans (SDLs)<br/>

                            </li>

                            <li>Member/Associate Member of CCIL means entities who have been granted membership of CCIL as per their membership policy; </li>
                            <li> NDS-OM means RBI’s screen based, anonymous electronic order matching system for trading in Government securities in the secondary market;</li>
                            <li> Odd Lot segment means Odd Lot segment of NDS-OM;</li>
                            <li> OTP means one-time-password;</li>
                            <li> OVD means Officially Valid Document defined under RBI-Know Your Customer (KYC) Direction, 2016, as amended from time to time;</li>
                            <li> Online portal means RBI Retail Direct Online portal;</li>
                            <li> Retail Direct Gilt Account (RDG Account) means gilt account maintained in the books of RBI under this Scheme;</li>
                            <li> Retail investors means individuals (natural persons);</li>
                            <li> Request for Quote (RFQ) mode means the on-screen negotiation system of RBI’s NDS-OM system;</li>
                            <li> SMS means short message service.</li>
                            <li> VFT means ‘Value Free Transfer’ of Government securities as permitted by RBI vide notification dated November 16, 2018, as amended from time to time
                            </li>
                        </ol>
                    </p>

                    <h5>II. Scope of the Scheme </h5>
                    <ol>
                        <li type="a">
                            ‘RBI Retail Direct’ is a comprehensive scheme which provides the following facilities to retail investors in government securities market through an online portal:
                            <ol type="i">


                                <li> Open and maintain a ‘Retail Direct Gilt Account’ (RDG Account)</li>
                                <li> Access to primary issuance of Government securities </li>
                                <li> Access to NDS-OM</li>
                            </ol>
                        </li>
                    </ol>
                    <h5>III. Eligibility</h5>
                    <p>
                        <ol type="a">
                            <li> Retail investors, as defined under the scheme, can register under the Scheme and maintain a RDG Account, if they have the following:
                                <ol type="i">


                                    <li> Permanent Account Number (PAN) issued by the Income Tax Department;</li>
                                    <li> Access to primary issuance of Government securities </li>
                                    <li> Any OVD for KYC purpose;</li>
                                    <li> Valid email id; and</li>
                                    <li> Registered mobile number</li>
                                </ol>

                            </li>
                            <li>
                                Non-Resident retail investors eligible to invest in Government Securities under Foreign Exchange Management Act, 1999 are eligible under the scheme.

                            </li>
                            <li>
                                The RDG account can be opened singly or jointly with another retail investor who meets the eligibility criteria.
                            </li>
                        </ol>
                    </p>
                    <h5> IV. Procedure</h5>
                    <p>

                        Registration
                        <ol type="i">

                            <li>
                                Investors can register on the online portal by filling up the online form and use the OTP received on the registered mobile number and email id to authenticate and submit the form.</li>

                            <li>
                                Instructions issued under RBI-Know Your Customer (KYC) Direction, 2016, updated from time to time, will be adhered to during onboarding the investors. Upon successful registration, ‘Retail Direct Gilt Account’ will be opened and details for accessing
                                the online portal will be conveyed through SMS/e-mail.
                            </li>
                            <li>
                                RDG Account shall be available for primary market participation as well as secondary market transactions on NDS-OM.
                            </li>
                            <p>Primary market participation</p>
                            <li>
                                Participation and allotment of securities will be as per the non-competitive scheme for participation in primary auction of government securities and procedural guidelines for SGB issuance.

                            </li>
                            <li>
                                Only one bid per security is permitted. On submission of the bid, the total amount payable will be displayed.
                            </li>
                            <li>
                                Payment to the aggregator / receiving office can be made through either of the following ways:
                                <ol type="a">
                                    <li>

                                        Using the net-banking/UPI facility from the linked bank account, whereby funds will be debited at the time of submission of bids on the portal.
                                    </li>
                                    <li>
                                        Using the UPI facility, whereby funds in the linked bank account can be blocked at the time of submission of bids on the portal which will be debited from this account on successful allotment in the auction. Similar facility through banks will be made
                                        available in due course.
                                    </li>
                                    <li>
                                        Refund, if any, will be credited to the investor’s bank account as per the timelines specified by the aggregator.
                                    </li>
                                </ol>


                            </li>
                            <li>
                                Allotted securities will be issued to the investors by credit to their RDG Account on the day of settlement.
                            </li>

                            <p>Secondary market transaction-NDS-OM</p>
                            <li>
                                Registered investors can access the secondary market transaction link on the online portal to buy or sell government securities through NDS-OM (odd lot segment/RFQ).
                            </li>
                            <p>Buy</p>
                            <li>
                                Payment can be made through either of the following ways:
                                <ol type="a">
                                    <li>
                                        Before start of trading hours or during the day, the investor should transfer funds to the designated account of CCIL (Clearing corporation of NDS-OM) using net-banking/UPI from the linked bank account. Based on actual transfer/success message, a funding
                                        limit (Buying Limit) will be given for placing ‘Buy’ orders. At the end of the trading session, any excess funds lying to the credit of the investor will be refunded.
                                    </li>
                                    <li>
                                        Using the UPI facility, whereby funds in the linked bank account can be blocked at the time of placing order which will be debited from this account on the day of settlement. Similar facility through banks will be made available in due course.
                                    </li>
                                </ol>
                            </li>
                            <li>
                                Securities purchased will be credited to the RDG Account on the day of settlement.
                            </li>
                            <p>Sell</p>
                            <li>
                                Securities identified for sale will be blocked at the time of placing order till the settlement of the trade.

                            </li>
                            <li>
                                Funds from the sale transactions will be credited to the linked bank account on the day of settlement.
                            </li>
                            <p>Non-Trade transactions – Value Free Transactions (VFT) </p>
                            <li>
                                Transactions permitted under VFT guidelines issued by RBI on November 16, 2018, as amended from time to time, as applicable to retail investors, will be available under the scheme.
                            </li>
                            <li>
                                For such purposes, the investors should submit an application on the online portal.
                            </li>
                        </ol>



                    </p>


                    <h5>V. Investor services</h5>
                    <p>
                        Registered investors can use the online portal for the following investor services:
                        <ol type="a">
                            <li>Account Statement</li>
                            <p>
                                Transaction history and balance position of securities holdings in the Retail Direct Gilt Account can be obtained from the link provided. All transaction alerts will be provided through e-mail/SMS.
                            </p>
                            <li>
                                Nomination facility
                            </li>
                            <p>
                                The nomination form in the prescribed format duly signed can be filled up and uploaded. There can be a maximum of two nominees. In the event of death of the registered investor, the securities available in the RDG Account can be transmitted to the RDG
                                Account or any other Government securities account of the nominee on submission of death certificate and transmission form.
                            </p>
                            <li>
                                Pledge/Lien
                            </li>
                            <p>
                                Securities held in the RDG Account will be available for pledge/lien
                            </p>
                            <li>
                                Gift Transactions
                            </li>
                            <p>
                                ‘Retail Direct Investors’ will have an online facility to gift government securities to other Retail Direct Investors.
                            </p>
                            <li>
                                Grievance redressal
                            </li>
                            <p>
                                Any query or grievances related to ‘Retail Direct’ Scheme can be raised on the portal which will be handled/resolved by Public Debt Office (PDO) Mumbai, RBI.
                            </p>
                        </ol>
                    </p>
                    <h5>VI. Fees and Charges</h5>
                    <p>
                        <ol type="a">
                            <li>
                                No fee will be charged for opening and maintaining ‘Retail Direct Gilt account’ with RBI.
                            </li>
                            <li>
                                No fee will be charged by the aggregator for submitting bids in the primary auctions.
                            </li>
                            <li>
                                Fee for payment gateway etc., as applicable, will be borne by the registered investor.
                            </li>
                        </ol>
                    </p>

          </div> 
          </div>
        </section>
      </main>
      <Footer />
    </div>) };export default AbtSchemeUI